/**
 * 过滤「持久化的过程步骤」，使其与会话区（实时流式）展示口径保持一致。
 *
 * 后端 SessionLogService 会把所有 trace（tool_call / load_skill / tool_result 等）
 * 原样落库；而会话区实时流式（useSubmitMessage 的 onTrace / onProgress）只展示其中
 * 「带命中文档名的检索结果」。历史回看（Ask History 详情等）若直接渲染原始 ProgressLog，
 * 就会多出实时视图里看不到的步骤。此函数把过滤规则收敛在一处，二者口径一致：
 *   - 丢弃 kind=progress（「正在加载/组装/调用…」进度提示，不展示）；
 *   - trace 仅保留 role=tool_result 且 toolResult 含 filename 的检索结果，
 *     其余 trace（tool_call / load_skill / 纯文本结果等）不展示；
 *   - reasoning / status / tool 等其它步骤原样保留。
 *
 * 规则需与 useSubmitMessage 中 onTrace 的实时过滤保持同步。
 */
export function filterDisplayProgressSteps(steps: unknown): any[] {
  if (!Array.isArray(steps)) return [];
  return steps.filter((step: any) => {
    if (!step || typeof step !== "object") return false;
    const kind = step.kind;
    if (kind === "progress") return false;
    if (kind === "trace") {
      const trace = step.trace && typeof step.trace === "object" ? step.trace : {};
      if (String(trace.role) !== "tool_result") return false;
      if (!Array.isArray(trace.toolResult)) return false;
      return trace.toolResult.some(
        (r: any) => typeof r?.filename === "string" && r.filename.trim(),
      );
    }
    return true;
  });
}
